import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { skeletonBusyProps, skeletonRoundedSx } from './skeletonCommon'

interface Props {
  readonly testId?: string
}

/** Auth / onboarding card while token or step data loads. */
export function AuthFormCardSkeleton({ testId = 'auth-form-card-skeleton' }: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      {...skeletonBusyProps}
      aria-label="Loading"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        py: 2,
      }}
    >
      <Skeleton variant="rounded" width={120} height={40} sx={skeletonRoundedSx} />
      <Skeleton variant="rounded" width="100%" height={28} sx={{ ...skeletonRoundedSx, maxWidth: 280 }} />
      <Skeleton variant="rounded" width="100%" height={20} sx={{ ...skeletonRoundedSx, maxWidth: 320 }} />
      <Skeleton variant="rounded" width="100%" height={48} sx={{ ...skeletonRoundedSx, maxWidth: 360, mt: 1 }} />
      <Skeleton variant="rounded" width="100%" height={48} sx={{ ...skeletonRoundedSx, maxWidth: 360 }} />
      <Skeleton variant="rounded" width="100%" height={44} sx={{ ...skeletonRoundedSx, maxWidth: 360, mt: 1 }} />
    </Box>
  )
}
